@if (country) {
  <div class="flex align-items-center">
    <div style="display: inline">
      <span [class]="'shadow-4 fi fi-list fi-' + countryIsoCode"></span>
    </div>
    <div class='ml-1 flex' style="flex: 1">
      {{ countryLabel }}
    </div>
  </div>
}
